import { cn } from '@/utils/styles';
import type { Section } from '@viome/viome-base/src/api/Strapi/StrapiTypes';

type AddonHowItWorksProps = {
  section: Section;
  className?: string;
};

export const AddonHowItWorks = ({
  section,
  className,
}: AddonHowItWorksProps) => {
  return (
    <div className={className}>
      <h2 className="font-sans text-xl font-medium text-[#111] tracking-tight mb-5">
        {section.title}
      </h2>
      <div className="flex flex-col">
        {section.items?.map((item, idx) => (
          <div
            key={idx}
            className={cn(
              'flex gap-3.5 pt-3.5',
              idx > 0 && 'border-t border-gray-100',
            )}
          >
            {item.iconUrl ? (
              <div className="bg-[#f0f8f7] rounded-full w-8 h-8 flex items-center justify-center shrink-0">
                <img
                  src={item.iconUrl}
                  alt=""
                  className="w-8 h-8 object-contain"
                />
              </div>
            ) : null}
            <div className="flex flex-col gap-1 pb-4">
              <p className="font-sans text-sm font-medium text-[#111] tracking-tight">
                {item.title}
              </p>
              <p className="font-sans font-light text-sm leading-[130%] text-tertiary">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
